import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(_component_q_icon, _mergeProps({
    name: _ctx.icon,
    title: _ctx.platform,
    class: _ctx.cssClass
  }, _ctx.$attrs), null, 16, ["name", "title", "class"]))
}